import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Output, inject } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SnackBarService } from '../../services/snack-bar-service.service';
import { AdmRedePostosServices } from '../adm-rede-postos.service';
import { AdmRedePosto, PerfisMasterInterface } from '../macro-posto.interface';

@Component({
  selector: 'app-criar-novo-usuario',
  templateUrl: './criar-novo-usuario.component.html',
  styleUrls: ['./criar-novo-usuario.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    MatSelectModule,
    MatDatepickerModule,
  ],
})
export class CriarNovoUsuarioComponent {
  public loading = false;
  public dialogRef = inject(MatDialogRef<CriarNovoUsuarioComponent>);
  private service = inject(AdmRedePostosServices);
  private snack = inject(SnackBarService);
  @Output() novoUsuarioCriado = new EventEmitter<string>();

  admRedePosto: AdmRedePosto = this.data.admRedePosto;
  //listaPerfis: PerfisMasterInterface[] = this.data.perfis || [];

  usuarioForm: FormGroup = new FormGroup({
    dscNome: new FormControl('', [Validators.required]),
    dscLogin: new FormControl('', [Validators.required]),
    dscEmail: new FormControl('', [Validators.required, Validators.email]),
    codPerfil: new FormControl('', [Validators.required]),
    numDddFone: new FormControl('', [
      Validators.pattern('^[0-9]{2}$'),
      Validators.minLength(2),
      Validators.maxLength(2),
    ]),
    numFone: new FormControl('', [
      Validators.pattern('^[0-9]{9}$'),
      Validators.minLength(9),
      Validators.maxLength(9),
    ]),
    indAtivo: new FormControl(true, [Validators.required]),
  });

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      admRedePosto: AdmRedePosto;
      perfis: PerfisMasterInterface[];
    }
  ) {
    this.service.buscarListaPerfis(this.admRedePosto.codEntidade).subscribe(
      (ret: any) => {
        console.log('ret', ret);
        this.usuarioForm.patchValue({
          codPerfil: ret[0]?.codPerfil || '',
        });
      },
      (error) => {
        console.log('error', error);
      }
    );
  }

  onCancelar(): void {
    this.dialogRef.close(false);
  }

  onConfirmar(): void {
    if (!this.usuarioForm.valid) {
      return;
    }
    this.loading = true;
    const result = this.usuarioForm.value;
    const novoUsuario = {
      Codentidade: this.admRedePosto.codEntidade,
      DscLoginEntidade: this.admRedePosto.dscLoginEntidade,
      dscNome: result.dscNome,
      dscLogin: result.dscLogin,
      dscIdentificacao: result.dscLogin,
      dscEmail: result.dscEmail,
      numDddFone: result.numDddFone,
      numFone: result.numFone,
      codPerfil: `${result.codPerfil}`,
      indAtivo: result.indAtivo,
    };

    this.service.criarNovoUsuario(novoUsuario).subscribe(
      (ret: any) => {
        if (ret && ret.sucesso) {
          this.loading = false;
          this.novoUsuarioCriado.emit(`add`);
          this.dialogRef.close(true);
        }
      },
      (error) => {
        this.snack.flashMessage(
          error.mensagens[0] || 'Erro ao criar usuario',
          ['snackbar-error'],
          'Fechar',
          3000
        );
      },
      () => {
        this.loading = false;
      }
    );
  }
}
